import React from 'react';
import { Container, Typography, Box, Skeleton } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import Page from 'src/components/Page';
import { useAuth } from 'src/context/auth/AuthContext';
import { useHeaderBreadcrumbs } from 'src/context/header/HeaderContext';
import { studentService } from 'src/services/student.service';
import { PendingTransactionsPanel } from 'src/components/student';

/** Bills and charges waiting for the scholar to pay. */
export default function Bills(): React.JSX.Element {
  const { user } = useAuth();

  const { data: studentId } = useQuery({
    queryKey: ['student', user?.id],
    queryFn: () => studentService.getStudentByUserId(user?.id as string),
    enabled: !!user?.id,
  });

  const { data: financialSummary } = useQuery({
    queryKey: ['student-financial-summary', studentId],
    queryFn: () => studentService.getStudentFinancialSummary(studentId as string),
    enabled: !!studentId,
  });

  useHeaderBreadcrumbs({ breadcrumbs: [{ label: 'Pay Bills' }] });

  return (
    <Page title="Pay Bills | Gold Minds Portal">
      <Container maxWidth={false} sx={{ px: { xs: 1, sm: 1.5, md: 2 }, pt: 0.5, pb: 4 }}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, fontSize: '1.375rem' }}>
            Pay Bills
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.8125rem' }}>
            Rent and other charges waiting for you. Pay before the due date to avoid late fees.
          </Typography>
        </Box>
        {studentId ? (
          <PendingTransactionsPanel
            studentId={studentId as string}
            currentBalance={Number(financialSummary?.currentBalance ?? 0)}
          />
        ) : (
          <Skeleton variant="rounded" height={120} />
        )}
      </Container>
    </Page>
  );
}
